import { useState, createContext, ReactNode, useRef, useEffect } from 'react';
import { useWallet } from '@/hooks/wallet';

export const RefreshContext = createContext<{
  refresh: () => void;
}>({
  refresh: () => undefined,
});

RefreshContext.displayName = 'RefreshContext';
interface Props {
  children: ReactNode;
}

export const RefreshProvider = (props: Props) => {
  const { children } = props;
  const [uid, setUid] = useState(0);
  const preWalletAddress = useRef('');
  const skipWalletAddress = useRef(true);
  const { evmWalletInfo } = useWallet();

  const refresh = () => {
    setUid(uid + 1);
  };

  // 切换钱包类型则重刷数据
  useEffect(() => {
    if (
      preWalletAddress.current !== evmWalletInfo.address &&
      !skipWalletAddress.current
    ) {
      refresh();
    }

    skipWalletAddress.current = false;
    preWalletAddress.current = evmWalletInfo.address;
  }, [evmWalletInfo.address]);

  return (
    <RefreshContext.Provider
      value={{
        refresh,
      }}
    >
      <div key={uid}>{children}</div>
    </RefreshContext.Provider>
  );
};
